import Markdown from '@components/Markdown';
import React, { FC } from 'react';
import { twMerge } from 'tailwind-merge';

interface NotificationItemProps {
  title: string;
  description: string;
  onClick?: () => void;
  isRead?: boolean;
}
const NotificationItem: FC<NotificationItemProps> = ({
  title,
  description,
  onClick,
  isRead,
}) => {
  return (
    <button
      data-testid="notification-item"
      className={twMerge(
        'flex gap-x-1 px-5 py-2 border-b border-neutral-50 text-start w-full',
        !isRead && 'bg-primary-50',
      )}
      onClick={onClick}
    >
      <div className="flex flex-col flex-1">
        <p className="text-sm text-neutral-80 mb-2 font-semibold capitalize line-clamp-1">
          {title}
        </p>
        <Markdown containerClassName="text-sm text-neutral-80 line-clamp-3">
          {description}
        </Markdown>
      </div>
      {!isRead && (
        <div
          data-testid="notification-item-badge"
          className="bg-danger-500 h-[15px] w-[15px] rounded-full m-[2.5px]"
        />
      )}
    </button>
  );
};

export default NotificationItem;
